<template>
    <div class="d-flex justify-content-center flex-wrap p-4">
        <div class="col-12 col-md-8">
            <DataTable :date="selectedDate" :tbody="tickets" @filterByDate="filterByDate" v-if="!loader && tickets"/>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import DataTable from "@/components/DataTables/TicketsDataTable.vue"
export default {
    name: 'TicketsView',
    components: {
        DataTable,
    },
    computed: {
        ...mapState(['loader', 'account']),
        ...mapGetters(['apiPath', 'omsApiPath', 'omsApiKey'])
    },
    data() {
        return {
            selectedDate: null,
            tickets: null
        }
    },
    methods: {
        ...mapMutations(['setLoader', 'setErrorFromServer']),
        async getTickets(startDate, endDate) {
            try {
                this.setLoader(true)

                if (!startDate && !endDate) {
                    startDate = moment().subtract(29, 'days').format('YYYY-MM-DD')
                    endDate = moment().format('YYYY-MM-DD')
                }

                const res = await this.$http.post(`${this.apiPath}/bank_cards/get`, { accounts_id: this.account.id }, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                })
                var bank_cards = res.data
                var AliasPanPath = ''
                for (var i = 0; i < bank_cards.length; i++) {
                    var bank_card = bank_cards[i]
                    AliasPanPath += `${bank_card.alias_pan}/`
                    if (bank_card.payment_account_reference) {
                        AliasPanPath += `${bank_card.payment_account_reference}/`
                    }
                }

                const response = await this.$http.get(`${this.omsApiPath}/tickets/get/${this.omsApiKey}/0/0/3:desc/${startDate}/${endDate}/${AliasPanPath}`)

                var tickets = response.data.payload
                for (var y = 0; y < tickets.length; y++) {
                    var ticket = tickets[y]
                    ticket.label = this.$formatLabel(ticket.label)
                    ticket.amount = this.$formatAmount(ticket.amount, ticket.currency)
                    
                    if (ticket.first_tap)  {
                        var first_tap_data = []
                        for (const [key, val] of Object.entries(ticket.first_tap)) {
                            first_tap_data.push({key, val})
                        }
                        ticket.first_tap = first_tap_data
                    }

                    if (ticket.last_tap)  {
                        var last_tap_data = []
                        for (const [key, val] of Object.entries(ticket.last_tap)) {
                            last_tap_data.push({key, val})
                        }
                        ticket.last_tap = last_tap_data
                    }

                    ticket.valid_from = this.$formatDate(ticket.valid_from, this.account.locales_id, Intl.DateTimeFormat().resolvedOptions().timeZone)
                    ticket.valid_to = this.$formatDate(ticket.valid_to, this.account.locales_id, Intl.DateTimeFormat().resolvedOptions().timeZone)
                }

                this.selectedDate = `${moment(startDate).format('DD/MM/YYYY')} - ${moment(endDate).format('DD/MM/YYYY')}`
                this.setLoader(false)
                return tickets
            } catch (err) {
                this.setErrorFromServer(err.message)
                this.setLoader(false)
            }
        },
        async filterByDate(when) {
            this.tickets = null
            this.tickets = await this.getTickets(when.startDate, when.endDate)
        }
    },
    async mounted() {
        this.tickets = await this.getTickets()
    }
}
</script>